export const getArtworkYear = editions => {
  const year = Array.isArray(editions) ? editions[0]?.year : null;

  return year == null || year.trim() === ""
    ? "year"
    : String(year).replace(/\//g, "-");
};
